import type { RootState } from 'store'

export const getInitialName = (state: RootState) =>
  state.award?.values?.initialName ?? ''
export const getNameChecking = (state: RootState) =>
  state.award?.values?.nameChecking ?? ''

export const getFullName = (state: RootState) =>
  state.award?.values?.fullName ?? ''
export const getShortName = (state: RootState) =>
  state.award?.values?.shortName ?? ''
export const getMinScore = (state: RootState) =>
  state.award?.values?.minScore ?? ''
export const getMaxScore = (state: RootState) =>
  state.award?.values?.maxScore ?? ''
export const getRoundScore = (state: RootState) =>
  state.award?.values?.roundScore ?? ''
export const getStepScore = (state: RootState) =>
  state.award?.values?.stepScore ?? ''
export const getLevel = (state: RootState) => state.award?.values?.level ?? ''
export const getLowerLimit = (state: RootState) =>
  state.award?.values?.lowerLimit ?? ''

export const getFullNameError = (state: RootState) =>
  state.award?.errors?.fullName ?? ''
export const getShortNameError = (state: RootState) =>
  state.award?.errors?.shortName ?? ''
export const getMinScoreError = (state: RootState) =>
  state.award?.errors?.minScore ?? ''
export const getMaxScoreError = (state: RootState) =>
  state.award?.errors?.maxScore ?? ''
export const getRoundScoreError = (state: RootState) =>
  state.award?.errors?.roundScore ?? ''
export const getStepScoreError = (state: RootState) =>
  state.award?.errors?.stepScore ?? ''
export const getLevelError = (state: RootState) =>
  state.award?.errors?.level ?? ''
export const getLowerLimitError = (state: RootState) =>
  state.award?.errors?.lowerLimit ?? ''
